import React from 'react'
import mobile from '../assets/images/01.png'

import app from '../assets/images/app.png'
import playstore from '../assets/images/playstore.png'
import { Link } from 'react-router-dom'

export default function App() {
  return (
        <div className="row align-items-center">
            <div className="col-lg-5 col-md-5 col-12">
                <img src={mobile} className="img-fluid mx-auto d-block" alt=""/>
            </div>

            <div className="col-lg-7 col-md-7 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                <div className="section-title">
                    <div className="alert alert-light alert-pills text-dark" role="alert">
                        <span className="badge bg-primary rounded-pill me-1">Apps</span>
                        <span className="content">Download now <i className="mdi mdi-arrow-right align-middle"></i></span>
                    </div>
                    <h4 className="title mb-3">Available for your <br/> Smartphones</h4>
                    <p className="text-muted para-desc mb-0">Our platform reaches people all over the world, hereby we are trusted as the best platform for crypto trading.</p>
                    <div className="my-4">
                        <Link to="#">
                            <img src={app} className="me-2" height="50" alt=""/>
                        </Link>

                        <Link to="#">
                            <img src={playstore} height="50" alt=""/>
                        </Link>
                    </div>

                    <div className="d-inline-block">
                        <div className="pt-4 d-flex align-items-center border-top">
                            <i data-feather="smartphone" className="fea icon-md me-2 text-primary"></i>
                            <div className="content">
                                <h6 className="mb-0">Install app now on your cellphones</h6>
                                <Link to="#" className="text-primary h6">Learn More <i className="mdi mdi-arrow-right"></i></Link>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}
